<script lang="ts">
    
    import { Input } from "sveltestrap";
    import type { Readable, Writable } from "svelte/store";
    import type { State } from "../Model/State";

    export let store: Writable<any> | Readable<any> | State;

</script>

<Input {...$$restProps} bind:value={$store} bind:checked={$store}>
    <slot />
</Input>